import styled from "styled-components"
import { Checkbox, Input } from 'linkdrop-ui'

export const InputStyled = styled(Input)`

`

export const CheckboxStyled = styled(Checkbox)`

`